// Icons
import { BsHouseFill } from "react-icons/bs";
import checkGreenIcon from "~/assets/icons/check-green.svg";
import closeRedIcon from "~/assets/icons/close-red.svg";

// Types
import type { IIdealHouseCompareProps } from "./types";

export function IdealHouseCompare({infocusID, OPTIONS,REP_PROJECT}: IIdealHouseCompareProps) {

    return ( <div data-infocusID={infocusID === 12}
        className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
                page-break
            "
    >
                <div className="w-full md:min-h-[43.75rem] max-sm:min-h-[10rem] h-auto flex flex-row flex-nowrap">
                    <div className="flex flex-col md:min-w-[19rem] md:max-w-[19rem] max-sm:flex-1 max-sm:min-w-[10rem] h-auto pt-[5.937rem] gap-[0.5rem] ">
                        <span className="w-full h-[2.187rem] pl-[0.625rem] rounded-l-[5.437rem] text-[0.90rem] font-medium text-[#707070] bg-[#cde9e1] flex flex-row flex-nowrap items-center justify-start">Súites</span>
                        <span className="w-full h-[2.187rem] pl-[0.625rem] rounded-l-[5.437rem] text-[0.90rem] font-medium text-[#707070] bg-[#cde9e1] flex flex-row flex-nowrap items-center justify-start">Banheiros</span>
                        <span className="w-full h-[2.187rem] pl-[0.625rem] rounded-l-[5.437rem] text-[0.90rem] font-medium text-[#707070] bg-[#cde9e1] flex flex-row flex-nowrap items-center justify-start">Vagas de garagem</span>

                        {
                            OPTIONS?.map((cOption, index) => (
                                <span key={index}
                                    className={`´w-full h-[2.187rem]
                                            pl-[0.625rem] rounded-l-[5.437rem]
                                            text-[0.90rem] font-medium
                                            text-[#707070] bg-[#cde9e1]
                                            flex flex-row flex-nowrap
                                            items-center justify-start
                                        `}
                                >
                                    {cOption.option}
                                </span>
                            ))
                        }
                    </div>
                    <div className="w-full flex flex-col overflow-hidden rounded-tr-[0.937rem] rounded-tl-[0.937rem]">
                        <div className="w-full max-w-[100%] h-auto flex flex-row flex-nowrap overflow-x-auto">
                            <div className="flex flex-col min-w-[19rem] max-w-[19rem] rounded-tl-[0.937rem] group/lastItem gap-[0.5rem] relative">
                                <div className="flex flex-col
                                        items-center justify-between
                                        rounded-tr-[0.937rem] rounded-tl-[0.937rem]
                                        overflow-hidden
                                        w-[12.25rem] min-h-[5.437rem]
                                    "
                                >
                                    <span className="w-full flex flex-row items-center gap-4 p-3 bg-gray-200">
                                        <BsHouseFill  size={22} />
                                        <span className="font-semibold text-xl">Casa Ideal</span>
                                    </span>
                                </div>

                                <span className={`w-full h-[2.187rem]
                                        bg-[#cde9e1]
                                        text-[0.90rem] font-medium
                                        text-[#707070]
                                        flex flex-row flex-nowrap
                                        items-center justify-start
                                        pl-[29%] group-last/lastItem:rounded-r-[1rem]
                                    `}
                                >
                                    {
                                        REP_PROJECT && REP_PROJECT?.houses?.reduce((a, b) => b.bedrooms > a ? b.bedrooms : a, 0)
                                    }
                                </span>

                                <span className={`w-full h-[2.187rem] text-[0.90rem] font-medium
                                    text-[#707070]
                                    bg-[#cde9e1]
                                    flex flex-row flex-nowrap
                                    items-center justify-start
                                    pl-[29%]
                                    `}
                                >
                                    {
                                        REP_PROJECT && REP_PROJECT?.houses?.reduce((a, b) => b.bathrooms > a ? b.bathrooms : a, 0)
                                    }
                                </span>

                                <span className={`w-full h-[2.187rem]  text-[0.90rem] font-medium bg-[#cde9e1]
                                        text-[#707070]
                                        flex flex-row flex-nowrap
                                        items-center justify-start
                                        pl-[29%] group-last/lastItem:rounded-r-[1rem]
                                    `}
                                >
                                    {
                                        REP_PROJECT && REP_PROJECT?.houses?.reduce((a, b) => b.parking_spaces > a ? b.parking_spaces : a, 0)
                                    }
                                </span>

                                {
                                    // @ts-ignore
                                    OPTIONS.map((hOption, hIndex) => {
                                        return (
                                            <span key={hIndex}
                                                className={`´w-full h-[2.187rem] bg-[#cde9e1] text-[0.90rem] font-medium text-[#707070] flex flex-row flex-nowrap items-center justify-start pl-[25%] group-last/lastItem:rounded-r-[1rem]`}
                                            >
                                                <img src={checkGreenIcon} alt="" className="!max-width-[1rem] h-auto" />
                                            </span>
                                        )
                                    })
                                }
                            </div>
                            {
                                REP_PROJECT && REP_PROJECT?.houses?.map((house, index) => (
                                    <div key={index} className="flex flex-col min-w-[19rem] max-w-[19rem] rounded-tl-[0.937rem] group/lastItem gap-[0.5rem] relative">
                                        <div className="flex flex-col
                                            items-center justify-between
                                            rounded-tr-[0.937rem] rounded-tl-[0.937rem]
                                            overflow-hidden
                                            w-[12.25rem] h-[5.437rem]
                                        "
                                        >
                                            <span className="w-full flex flex-row items-center gap-4 px-3 py-2 rounded-md bg-gray-200">
                                                <span className="font-semibold text-sm">
                                                    {house.name}
                                                </span>
                                            </span>
                                        </div>

                                        <span key={index}
                                            className={`´w-full h-[2.187rem]
                                                bg-[#cde9e1]
                                                text-[0.90rem] font-medium
                                                text-[#707070]
                                                flex flex-row flex-nowrap
                                                items-center justify-start
                                                pl-[29%] group-last/lastItem:rounded-r-[1rem]
                                            `}
                                        >
                                            {house.bedrooms}
                                        </span>

                                        <span key={index}
                                            className={`´w-full h-[2.187rem] text-[0.90rem] font-medium
                                                bg-[#cde9e1]
                                                text-[#707070]
                                                flex flex-row flex-nowrap
                                                items-center justify-start
                                                group-last/lastItem:rounded-r-[1rem]
                                                pl-[29%]
                                    `}
                                        >
                                            {house.bathrooms}
                                        </span>

                                        <span key={index}
                                            className={`´w-full h-[2.187rem]  text-[0.90rem] font-medium bg-[#cde9e1]
                                                text-[#707070]
                                                flex flex-row flex-nowrap
                                                items-center justify-start
                                                pl-[29%] group-last/lastItem:rounded-r-[1rem]
                                    `}
                                        >
                                            {house.parking_spaces}
                                        </span>

                                        {
                                            // @ts-ignore
                                            OPTIONS.map((hOption, hIndex) => {
                                                const houseAlreadyOption = house && house?.home_options?.find((cOption) => cOption.option === hOption.option && cOption.id === hOption.id)

                                                if (houseAlreadyOption) return (
                                                    <span key={hIndex}
                                                        className={`´w-full h-[2.187rem] bg-[#cde9e1] text-[0.90rem] font-medium text-[#707070] flex flex-row flex-nowrap items-center justify-start pl-[25%] group-last/lastItem:rounded-r-[1rem]`}
                                                    >
                                                        <img src={checkGreenIcon} alt="" className="!max-width-[1rem] h-auto" />
                                                    </span>
                                                )

                                                if (!houseAlreadyOption) return (
                                                    <span key={hIndex}
                                                        className={`´w-full h-[2.187rem] bg-[#cde9e1] text-[0.90rem] font-medium text-[#707070] flex flex-row flex-nowrap items-center justify-start pl-[25%] group-last/lastItem:rounded-r-[1rem]`}
                                                    >
                                                        <img src={closeRedIcon} alt="" className="!max-width-[1rem] h-auto" />
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
    )
}
